
import { Component, Vue, Ref } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import { AppModule } from '@/store/modules/app'
import { pickBy } from 'lodash'
import CompanyDetailForm from './components/company_detail_form.vue'
// eslint-disable-next-line
import AvatarUpload, { AvatarUploadIns } from '@/components/avatar_upload/index.vue'
// eslint-disable-next-line
import DynamicTags, { ins } from '@/components/dynamic_tags/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import FullLoading from '@/components/full_loading/index.vue'
import UploadImg from '@/common/class/UploadImg'

@Component({
    name: 'company-detail',
    components: {
        CompanyDetailForm,
        DynamicTags,
        AvatarUpload,
        RowWrap,
        CreateDetailLayout,
        FullLoading
    }
})
export default class extends Vue {
    private isUpdateLoading = false
    private loading = true
    private keywords: string[] = []
    private stopwords: string[] = [] 
    private bKeywords: string[] = []
    private form: any = {}
    private avatar = ''
    @Ref('formRef') private formEl!: any
    @Ref('keywordRef') private keywordEl!: ins
    @Ref('stopwordRef') private stopwordEl!: ins
    @Ref('bkeywordRef') private bkeywordEl!: ins
    @Ref('avatarRef') private avatarEl!: AvatarUploadIns

    private created() {
        this.$title('Loading | 机构详情 - 庖丁')
    }

    private async mounted() {
        await AppModule.getIndustry()
        await this.getCompanyDetail()
        this.loading = false
    }

    /** 获取机构详情 */
    private async getCompanyDetail() {
        const result = await EnterpriseService.getCompanyDetail({ id: +this.$route.params.id })
        if (result.status === 200) {
            this.$title(`${result.data.name} | 机构详情 - 庖丁`)
            this.avatar = result.data.logo
            this.keywords = result.data.keywords
            this.stopwords = result.data.stopwords
            this.bKeywords = result.data.b_keywords
            // 忽略的字段
            const excludeKeys = ['logo', 'keywords', 'stopwords', 'b_keywords', 'company_type', 'industry']
            this.form = {
                ...pickBy(result.data, (value, key) => !excludeKeys.includes(key)),
                company_type_id: result.data.company_type.id,
                industry_ids: (() => {
                    let { industry } = result.data
                    const splitId = (id: number) => {
                        let strId = String(id)
                        let ids = [+strId.substr(0, 2)]
                        if (strId.length > 2) {
                            ids.push(+strId.substr(0, 4))
                        }
                        if (strId.length > 4) {
                            ids.push(id)
                        }
                        return ids
                    }
                    return industry.map((n: any) => splitId(n.id))
                })(),
                products: result.data.products.map((n: any, i: number) => ({ ...n, key: `p${i}` }))
            }
        }
    }

    private onUpdate() {
        this.formEl.validate(async (company: any) => {
            this.showLoading()
            const keywords = this.keywordEl.getTags()
            const stopwords = this.stopwordEl.getTags()
            const bkeywords = this.bkeywordEl.getTags()
            const imgFile = this.avatarEl.getFile()
            let avatarResult: any
            // 上传图片
            if (typeof imgFile !== 'string') {
                avatarResult = await new UploadImg(imgFile).upload()
                if (avatarResult.error) {
                    this.$mwarning('图片上传失败')
                    avatarResult = ''
                } else {
                    avatarResult = avatarResult.key
                }
            } else {
                avatarResult = imgFile
            }
            
            const params = {
                ...company,
                keywords,
                b_keywords: bkeywords,
                stopwords: stopwords,
                logo: avatarResult
            }
            const result = await EnterpriseService.updateCompanyInfo(params)
            this.hideLoading()
            if (result.status === 200) {
                return this.$msuccess('修改成功')
            }
            this.$merror(result.message || '发生错误, 请稍后再试')
        })
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }
}
